import { Typography } from '@atlas-metrics/design-system';

import Tabs, { Tab } from './ui/Tabs';

interface IProps {
  selectedStandard: string;
  setSelectedStandard: (val: string) => void;
  standardsTabsData: Tab[];
  className?: string;
}

const StandardTabs = ({
  selectedStandard,
  setSelectedStandard,
  standardsTabsData,
  className,
}: IProps) => {
  return (
    <Tabs
      className={className}
      tabsList={standardsTabsData.map((tab) => ({
        ...tab,
        label: (
          <Typography
            variant='body-m'
            className='w-full max-w-[130px] truncate whitespace-nowrap px-2 text-ds-grey-950'
            bold
          >
            {tab.label}
          </Typography>
        ),
      }))}
      defaultValue={standardsTabsData[0]?.value}
      value={selectedStandard}
      onValueChange={(val) => {
        setSelectedStandard(val);
      }}
    />
  );
};

export default StandardTabs;
